const TIME_BEFORE_LOGOUT = 890000;

const LOGOUT_DELAY = 10000;

const ACTION_DELAY = 250;

export { ACTION_DELAY, LOGOUT_DELAY, TIME_BEFORE_LOGOUT };
